import { Component, EventEmitter, Input, OnInit, Output }                 from '@angular/core';
import { animate, keyframes, query, stagger, style, transition, trigger } from '@angular/animations';

import { Location }    from '@angular/common';
import { ActionModel } from './action.model';

@Component({
  selector: 'sc-new-actions',
  templateUrl: './new-actions.component.html',
  styleUrls: ['./new-actions.component.scss'],
  animations: [
    trigger('flyInOut', [
      transition('out => in', [
        query(
          '.animate',
          stagger('100ms', [
            animate(
              500,
              keyframes([
                style({
                  opacity: 0,
                  transform: 'translateX(150px)',
                  offset: 0
                }),
                style({
                  opacity: 0.5,
                  transform: 'translateX(-15px)',
                  offset: 0.5
                }),
                style({ opacity: 1, transform: 'translateX(0)', offset: 1.0 })
              ])
            )
          ])
        )
      ]),

      transition('in => out', [
        query(
          '.animate',
          stagger('100ms', [
            animate(
              500,
              keyframes([
                style({ opacity: 1, transform: 'translateX(0)', offset: 0 }),
                style({
                  opacity: 0.5,
                  transform: 'translateX(-15px)',
                  offset: 0.5
                }),
                style({
                  opacity: 0,
                  transform: 'translateX(150px)',
                  offset: 1.0
                })
              ])
            )
          ])
        )
      ])
    ])
  ]
})
export class NewActionsComponent implements OnInit {
  @Input() public actionModel: ActionModel;

  @Output() public postEvent = new EventEmitter();
  @Output() public putEvent = new EventEmitter();
  @Output() public duplicateEvent = new EventEmitter();
  @Output() public duplicateMasseEvent = new EventEmitter();
  @Output() public editEvent = new EventEmitter();
  @Output() public deleteEvent = new EventEmitter();
  @Output() public submitToValidationEvent = new EventEmitter();
  @Output() public submitToValidationByMailEvent = new EventEmitter();
  @Output() public addEvent = new EventEmitter();
  @Output() public setGroupEvent = new EventEmitter();
  @Output() public cancelEvent = new EventEmitter();
  @Output() public validateEvent = new EventEmitter();
  @Output() public validateAllEvent = new EventEmitter();
  @Output() public AddNewRightEvent = new EventEmitter();
  @Output() public createDuplicateEvent = new EventEmitter();
  @Output() public protectEvent = new EventEmitter();
  @Output() public downloadDraftPdfEvent = new EventEmitter();
  @Output() public downloadPdfEvent = new EventEmitter();
  @Output() public addInSessionEvent = new EventEmitter();
  @Output() public updateInSessionEvent = new EventEmitter();
  @Output() public undoConfirmEvent = new EventEmitter();
  @Output() public sendEmailEvent = new EventEmitter();
  @Output() public sendNodNotificationEvent = new EventEmitter();
  @Output() public displayNodEvent = new EventEmitter();
  @Output() public displayWorkflowEvent = new EventEmitter();
  @Output() public refuseEvent = new EventEmitter();
  @Output() public dateClosingEvent = new EventEmitter();
  @Output() public downloadXlsxEvent = new EventEmitter();
  @Output() public downloadSecondXlsxEvent = new EventEmitter();
  @Output() public massSetOkNotificationEvent = new EventEmitter();
  @Output() public downloadDocumentEvent = new EventEmitter();
  @Output() public pdfEmitter = new EventEmitter();
  @Output() public useAsModelEvent = new EventEmitter();
  @Output() public deliverEvent = new EventEmitter();
  @Output() public cancelTurnoverEvent = new EventEmitter();
  @Output() public setOkTacturationEvent = new EventEmitter();
  @Output() public downloadInvoiceDocumentAllEvent = new EventEmitter();
  @Output() public takeTurnoverValidationEvent = new EventEmitter();
  @Output() public excelImportEvent = new EventEmitter();
  @Output() public createContractEvent = new EventEmitter();
  @Output() public importDocumentEvent = new EventEmitter();
  @Output() public postLineExtractionEvent = new EventEmitter();
  @Output() public settingsEvent = new EventEmitter();
  @Output() public searchEvent = new EventEmitter();

  public state = 'out';

  public isToggle = false;
  public isOnMenu = false;
  public show = false;
  public alreadyClicked = false;
  public isMouseOver;
  private: any;

  constructor(private location: Location) {
  }

  public ngOnInit(): void {
  }

  public isAlreadyClick() {
    if (!this.alreadyClicked) {
      this.alreadyClicked = true;
      setTimeout(() => {
        this.alreadyClicked = false;
      }, 2000);
      return false;
    }
    return true;
  }

  public mouseEnter() {
    this.state = 'in';
    setTimeout(() => {
      this.show = true;
    }, 500);
  }

  public mouseLeave() {
    this.isMouseOver = false;
    setTimeout(() => {
      if (!this.isMouseOver) {
        this.state = 'out';
        this.show = false;
      }
    }, 3000);
  }

  public post() {
    this.postEvent.emit();
  }

  public AddNewRight() {
    this.AddNewRightEvent.emit();
  }

  public put() {
    this.putEvent.emit();
  }

  public duplicate() {
    this.duplicateEvent.emit();
  }

  public duplicateMasse() {
    this.duplicateMasseEvent.emit();
  }

  public edit() {
    this.editEvent.emit();
  }

  public delete() {
    this.deleteEvent.emit();
  }

  public undoConfirm() {
    this.undoConfirmEvent.emit();
  }

  public undo() {
    this.location.back();
  }

  public submitToValidation() {
    this.submitToValidationEvent.emit();
  }

  public submitToValidationByMail() {
    this.submitToValidationByMailEvent.emit();
  }

  public massSetOkNotification() {
    this.massSetOkNotificationEvent.emit();
  }

  public add() {
    this.addEvent.emit();
  }

  public addInSession() {
    this.addInSessionEvent.emit();
  }

  public updateInSession() {
    this.updateInSessionEvent.emit();
  }

  public cancel() {
    this.cancelEvent.emit();
  }

  public validate() {
    this.validateEvent.emit();
  }

  public validateAll() {
    this.validateAllEvent.emit();
  }

  public createDuplicate() {
    this.createDuplicateEvent.emit();
  }

  public pdf() {
    this.pdfEmitter.emit();
  }

  public setGroup() {
    this.setGroupEvent.emit();
  }

  public protect() {
    this.protectEvent.emit();
  }

  public downloadDraftPdf() {
    this.downloadDraftPdfEvent.emit();
  }

  public downloadPdf() {
    this.downloadPdfEvent.emit();
  }

  public sendEmail() {
    this.sendEmailEvent.emit();
  }

  public sendNodNotification() {
    this.sendNodNotificationEvent.emit();
  }

  public displayNod() {
    this.displayNodEvent.emit();
  }

  public displayWorkflow() {
    this.displayWorkflowEvent.emit();
  }

  public refuse() {
    this.refuseEvent.emit();
  }

  public closingDate() {
    this.dateClosingEvent.emit();
  }

  public downloadXlsx() {
    this.downloadXlsxEvent.emit();
  }

  public downloadSecondXlsx() {
    this.downloadSecondXlsxEvent.emit();
  }

  public downloadDocument() {
    this.downloadDocumentEvent.emit();
  }

  public useAsModel(): void {
    this.useAsModelEvent.emit();
  }

  public cancelTurnover(): void {
    this.cancelTurnoverEvent.emit();
  }

  public setOkFacturation(): void {
    this.setOkTacturationEvent.emit();
  }

  public downloadInvoiceDocumentAll(): void {
    this.downloadInvoiceDocumentAllEvent.emit();
  }

  public takeTurnoverValidation(): void {
    this.takeTurnoverValidationEvent.emit();
  }

  public excelImport(): void {
    this.excelImportEvent.emit();
  }

  public createContract(): void {
    this.createContractEvent.emit();
  }

  public importDocument(): void {
    this.importDocumentEvent.emit();
  }

  public postLineExtraction(): void {
    this.postLineExtractionEvent.emit();
  }

  settings() {
    this.settingsEvent.emit();
  }

  public search() {
    this.searchEvent.emit();
  }
}
